import { Satellite } from "@material-ui/icons";
import { createSlice } from "@reduxjs/toolkit";
import Restaurant from "../Actions/GetRestaurant-Action";
const initialState = {
  restaurantData: [],
  searchRestaurant:[],
  showSearch:false,
  loading: false,
  status: "",
  isLoaded: false,
  lastEvaluatedkey: "",
  loadMore: false,
};

const Restaurants = createSlice({
  name: "Resturants list",
  initialState,
  reducers: {
    setIsLoaded(state, action) {
      state.isLoaded = action.payload;
    },
    setShowSearch(state, action) {
      state.showSearch = action.payload;
    },
    setSearchRestaurant(state, action) {
      state.searchRestaurant = action.payload;
    },
    setLoadMore(state, action) {
      state.loadMore = action.payload;
    },
    changeStatus(state, action) {
      return { ...state, restaurantData: action.payload, isLoaded: true };
    },
    addNewRestaurant(state, action) {
      return { ...state, restaurantData: action.payload, isLoaded: true };
    },
    editRestaurant(state, action) {
      state.restaurantData[action.payload.index] = action.payload.newItem;
    },
  },
  extraReducers: {
    [Restaurant.pending]: (state, action) => {
      if (state.lastEvaluatedkey === "") {
        state.loading = true;
      } else {
        state.loadMore = true;
      }
    },
    [Restaurant.fulfilled]: (state, action) => {
      if (action.payload.error) {
        state.status = action.payload.error;
        state.loading = false;
        state.loadMore = false;
        return;
      }
      let currentArr = state.restaurantData;
      let newArr = [];
      newArr = action.payload.res;
      state.restaurantData = currentArr.concat(newArr);
      state.lastEvaluatedkey = action?.payload?.lastEvalutedkey || "";
      state.loading = false;
      state.loadMore = false;
    },
    [Restaurant.rejected]: (state, action) => {
      state.loading = false;
      state.status = action.error.message;
      state.loadMore = false;
    },
  },
});

export const RestaurantAction = Restaurants.actions;

export default Restaurants.reducer;
